/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for CaseProgramsProductDeliveries.
 *
 */

import { ReduxUtils } from '@spm/core';

const GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `CASEPROGRAMSPRODUCTDELIVERIES/GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID`
);

export { GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID };
